import { BaseUrl } from './base_url_enum'
import Api from './index'
import { IPayment } from '../models/payment'

type IPaymentsResponse = {
  relation: IPayment[]
}

export const getPayments = (relationNumber: number) =>
  Api<IPaymentsResponse>('GET', `relations/${relationNumber}/payment-details`, BaseUrl.Afd)
